type IdParam = (id: string | number) => string;

type AdminApiEndpoints = {
      UPLOAD_FILE: string;

      COURSE: {
        CREATE: string;
        GET_BY_UNIVERSITY_AND_VARIANT: (universityId: number, variant: string) => string;
        GET_BY_UNIVERSITY_SETTINGS_ID: (universitySettingsId: number) => string;
        GET_BY_UNIVERSITY_ID: (universityId: number) => string;
        GET_ACTIVE_BY_UNIVERSITY_ID: (universityId: number) => string;
        UPDATE: (id: number) => string;
        DELETE: (id: number) => string;
      };

      UNIVERSITY_SETTINGS: {
        GET_BY_UNIVERSITY_ID: (universityId: number) => string;
        GET_BY_UNIVERSITY_AND_SECTION: (universityId: number, section: string) => string;
        UPDATE_BY_UNIVERSITY_ID: (universityId: number) => string;
        CREATE_BY_UNIVERSITY_ID: (universityId: number) => string;
      };

      UNIVERSITY: {
        GET_CONTENT: (university_id: string) => string;
        UPDATE_INFO: IdParam;
    
        ABOUT: {
          GET_DETAILS_BY_ID: (id: number) => string;
          UPDATE: (id: number) => string;
        };
      };

      BANNER: {
        CREATE: string;
        UPDATE: (id: number) => string;
        DELETE: (id: number) => string;
        GET_ALL: (pageTypeId: number) => string;
      };

      HEADER: {
        CREATE: string;
        UPDATE: (id: number) => string;
        DELETE: (id: number) => string;
        GET_ALL: (pageTypeId: number) => string;
      };

      LEARNERS: {
        CREATE: string;
        UPDATE: (id: number) => string;
      };

      SCHOLAR: {
        CREATE: string;
        UPDATE: (id: number) => string;
      };

      ABOUT: {
        CREATE: string;
        UPDATE: (id: number) => string;
      };

      ACCORDION: {
        CREATE: string;
        UPDATE: (id: number) => string;
        GET_BY_PAGE_ID: (pageId: number) => string;
        DELETE: (id: number) => string;
      };

      ACCREDITATION: {
        CREATE: string;
        UPDATE: (id: number) => string;
      };

      KEY_NUMBERS: {
        CREATE: string;
        UPDATE: (id: number) => string;
      };

      DIGITAL_LEARNING: {
        CREATE: string;
        UPDATE: (id: number) => string;
      };

      ACADEMIC_DELIVERABLES: {
        CREATE: string;
        UPDATE: (id: number) => string;
      };

      MESSAGE: {
        CREATE: string;
        UPDATE: (id: number) => string;
      };

      MOBILE_APP: {
        CREATE: string;
        UPDATE: (id: number) => string;
      };

      PLACEMENTS: {
        CREATE: string;
        UPDATE: (id: number) => string;
      };

      TESTIMONIALS: {
        CREATE: string;
        UPDATE: (id: number) => string;
      };

      RECRUITERS: {
        CREATE: string;
        UPDATE: (id: number) => string;
      };

      ELIGIBILITY: {
        CREATE: string;
        UPDATE: (id: number) => string;
        CLONE: string;
        GET_BY_COMPONENT_ID: (componentId: number) => string;
        CATEGORY: {
          CREATE: string;
          UPDATE: (id: number) => string;
          DELETE: (id: number) => string;
          GET_BY_COMPONENT_ID: (componentId: number) => string;
          GET_BY_ID: (id: number) => string;
        };
      };

      COUNSELING: {
        CREATE: string;
        UPDATE: (id: number) => string;
        GET_BY_PAGE_ID: (pageId: number) => string;
        DELETE: (id: number) => string;
      };

      COURSE_SPECIALISATION: {
        CREATE: string;
        UPDATE: (id: number) => string;
        GET_BY_ID: (id: number) => string;
        GET_BY_PAGE_ID: (pageId: number) => string;
        DELETE: (id: number) => string;
      };

      HIGHER_QUALIFICATION: {
        CREATE: string;
        UPDATE: (id: number) => string;
        GET_BY_UNIVERSITY_SETTINGS_ID: (universitySettingsId: number) => string;
        DELETE: (id: number) => string;
      };

      LEAD_DROP_FORM: {
        CREATE: string;
        UPDATE: (id: number) => string;
        GET_BY_UNIVERSITY_ID: (universityId: number) => string;
        GET_BY_UNIVERSITY_AND_VARIANT: (universityId: number, variant: string) => string;
        DELETE: (id: number) => string;
      };

      LEAD_DROP_POPUP: {
        CREATE: string;
        UPDATE: (id: number) => string;
        GET_BY_UNIVERSITY_ID: (universityId: number) => string;
        GET_BY_UNIVERSITY_AND_VARIANT: (universityId: number, variant: string) => string;
        DELETE: (id: number) => string;
      };

      LEAD_FORM_OPTIONS: {
        GROUPS: (kind: string, universityId: number) => string;
        CREATE_GROUP: (kind: string) => string;
        UPDATE_GROUP: (kind: string, id: number) => string;
        DELETE_GROUP: (kind: string, id: number) => string;
        ASSIGN_ITEMS: (kind: string, id: number) => string;
        ITEMS: (kind: string, universityId: number) => string;
        CREATE_ITEM: (kind: string) => string;
        UPDATE_ITEM: (kind: string, id: number) => string;
        DELETE_ITEM: (kind: string, id: number, universityId: number) => string;
        SET_ITEMS_GROUP: (kind: string) => string;
        RESOLVE: (source: string, universityId: number, group?: string) => string;
      };

      CUSTOM_LEAD_FORM: {
        DESTINATIONS: string;
        USAGE: (id: number, universityId: number) => string;
        BULK_LINK: (id: number) => string;
        BULK_UNLINK: (id: number) => string;
        LIST: (universityId: number, formType?: string) => string;
        CREATE: string;
        GET_BY_ID: (id: number) => string;
        UPDATE: (id: number) => string;
        DELETE: (id: number) => string;
      };

      LEAD_FORM_CONFIG: {
        CATALOG: string;
        VALIDATE: string;
        LIST: (universityId: number) => string;
        CREATE: string;
        GET_BY_ID: (id: number) => string;
        UPDATE: (id: number) => string;
        DELETE: (id: number) => string;
      };

      MOBILE_LEAD_FORM: {
        CREATE: string;
        UPDATE: (id: number) => string;
        GET_BY_COMPONENT_ID: (componentId: number) => string;
        DELETE: (id: number) => string;
      };

      PROGRAM_PROSPECTS: {
        CREATE: string;
        UPDATE: (id: number) => string;
        GET_BY_PAGE_ID: (pageId: number) => string;
        DELETE: (id: number) => string;
      };

      SPECIALISATION: {
        CREATE: string;
        UPDATE: (id: number) => string;
      };

      CAREER_PROSPECTS: {
        CREATE: string;
        UPDATE: (id: number) => string;
      };

      CERTIFICATION: {
        CREATE: string;
        UPDATE: (id: number) => string;
      };

      APPLICATION_PROCESS: {
        CREATE: string;
        UPDATE: (id: number) => string;
      };

      SKILLS: {
        CREATE: string;
        UPDATE: (id: number) => string;
      };

      COMPARISON: {
        CREATE: string;
        UPDATE: (id: number) => string;
      };

      LEADERS: {
        CREATE: string;
        UPDATE: (id: number) => string;
      };

      WHO_IS_THIS_PROGRAM_FOR: {
        CREATE: string;
        UPDATE: (id: number) => string;
      };

      BANNER_VIDEO: {
        CREATE: string;
        UPDATE: (id: number) => string;
      };

      WALK_THROUGH: {
        CREATE: string;
        UPDATE: (id: number) => string;
      };

      LIFE_MILESTONE: {
        CREATE: string;
        UPDATE: (id: number) => string;
      };

      SPECIALISATION_CAROUSEL: {
        CREATE: string;
        UPDATE: (id: number) => string;
      };

      ENROLLMENTS: {
        CREATE: string;
        UPDATE: (id: number) => string;
      };

      SUCCESS_STORIES: {
        CREATE: string;
        UPDATE: (id: number) => string;
      };

      WHAT_MAKES_COURSE_DIFFERENT: {
        CREATE: string;
        UPDATE: (id: number) => string;
      };

      VICE_CHANCELLOR: {
        CREATE: string;
        UPDATE: (id: number) => string;
      };

      FACULTY: {
        CREATE: string;
        UPDATE: (id: number) => string;
      };

      MASTERCLASS: {
        CREATE: string;
        UPDATE: (id: number) => string;
      };

      FOOTER: {
        CREATE: string;
        UPDATE: (id: number) => string;
        GET_BY_ID: (id: number) => string;
        GET_BY_COMPONENT_ID: (componentId: number) => string;
        DELETE: (id: number) => string;
        CLONE: string;
        CATEGORY: {
            CREATE: string;
            UPDATE: (id: number) => string;
            DELETE: (id: number) => string;
            GET_BY_COMPONENT_ID: (componentId: number) => string;
        };
        ITEM: {
            CREATE: string;
            UPDATE: (id: number) => string;
            DELETE: (id: number) => string;
            GET_BY_CATEGORY_ID: (categoryId: number) => string;
        };
      };

      SUBSCRIBE: {
        CREATE: string;
        UPDATE: (id: number) => string;
      };

      PROGRAM_CARDS: {
        CREATE: string;
        UPDATE: (id: number) => string;
        GET_BY_COMPONENT_ID: (componentId: number) => string;
        CLONE: string;
        CATEGORY: {
          CREATE: string;
          UPDATE: (id: number) => string;
          DELETE: (id: number) => string;
          GET_BY_COMPONENT_ID: (componentId: number) => string;
        };
        CARD: {
          CREATE: string;
          UPDATE: (id: number) => string;
          DELETE: (id: number) => string;
          GET_BY_CATEGORY_ID: (categoryId: number) => string;
        };
      };

      COURSE_OUTCOME: {
        CREATE: string;
        UPDATE: (id: number) => string;
      };

      THANK_YOU: {
        CREATE: string;
        UPDATE: (id: number) => string;
      };
      RICH_TEXT_EDITOR: {
        CREATE: string;
        UPDATE: (id: number) => string;
      };
      BLOG_WITH_LEAD: {
        CREATE: string;
        UPDATE: (id: number) => string;
      };
      LATEST_BLOG: {
        CREATE: string;
        UPDATE: (id: number) => string;
        SOURCES: (pageId: number) => string;
      };
      POPULAR_BLOG: {
        CREATE: string;
        UPDATE: (id: number) => string;
        SOURCES: (pageId: number) => string;
      };
      BLOG_LIST: {
        CREATE: string;
        UPDATE: (id: number) => string;
      };
      BLOG_CATEGORY: {
        LIST: string;
        GET_BY_ID: (id: number) => string;
        CREATE: string;
        UPDATE: (id: number) => string;
        DELETE: (id: number) => string;
      };
      AUTHOR: {
        LIST: string;
        GET_BY_ID: (id: number) => string;
        LINKED_PAGES: (id: number) => string;
        CREATE: string;
        UPDATE: (id: number) => string;
        DELETE: (id: number) => string;
      };
      AUTHOR_PROFILE: {
        CREATE: string;
        UPDATE: (id: number) => string;
      };
      AUTHOR_CARD: {
        CREATE: string;
        UPDATE: (id: number) => string;
      };
      AUTHOR_BYLINE: {
        CREATE: string;
        UPDATE: (id: number) => string;
      };
      COUNSELOR_CALL_CTA: {
        CREATE: string;
        UPDATE: (id: number) => string;
      };
      BREADCRUMB_BANNER: {
        CREATE: string;
        UPDATE: (id: number) => string;
      };
      BLOG_INLINE_IMAGE: {
        CREATE: string;
        UPDATE: (id: number) => string;
      };
      PARA_TEXT: {
        CREATE: string;
        UPDATE: (id: number) => string;
      };
      HEADING: {
        CREATE: string;
        UPDATE: (id: number) => string;
      };
      SKILL_CARDS: {
        CREATE: string;
        UPDATE: (id: number) => string;
      };
      LEARN_FROM_LEADERS: {
        CREATE: string;
        UPDATE: (id: number) => string;
        GET_BY_COMPONENT_ID: (componentId: number) => string;
      };
      REFERRAL_FORM: {
        CREATE: string;
        UPDATE: (id: number) => string;
      };
      INFLUENCER_FORM: {
        CREATE: string;
        UPDATE: (id: number) => string;
      };
      GRIEVANCE_FORM: {
        CREATE: string;
        UPDATE: (id: number) => string;
      };

      PAGE: {
        GET_ALL: string;
        GET_BY_ID: (id: string | number) => string;
        CREATE: string;
        UPDATE: (id: string | number) => string;
        DELETE: (id: string | number) => string;
        CLONE: (id: string | number) => string;
      };

      PAGE_COMPONENT: {
        CREATE: string;
        GET_BY_PAGE_ID: (page_id: number) => string;
        GET_BY_ID: (id: number) => string;
        UPDATE: (id: number) => string;
        DELETE: (id: number) => string;
        REORDER: (page_id: number) => string;
      };

      WIDGET_BLOCK: {
        LIST: string;
        GET_BY_ID: (id: string | number) => string;
        CREATE: string;
        UPDATE: (id: string | number) => string;
        DELETE: (id: string | number) => string;
        USAGE: (id: string | number) => string;
        BULK_PLACE: (id: string | number) => string;
        BULK_REMOVE: (id: string | number) => string;
      };

      WIDGET_MANAGEMENT: {
        INVENTORY: string;
        USAGE: string;
        BULK_DELETE: string;
        BULK_CLONE: string;
      };

      NAVBAR: {
        CREATE: string;
        UPDATE: (id: number) => string;
        GET_BY_ID: (id: number) => string;
        CLONE: string;
      };
      MENU_ITEM: {
        CREATE: string;
        UPDATE: (id: number) => string;
        DELETE: (id: number) => string;
        GET_ALL: string;
        GET_BY_NAVBAR_ID: (navbarId: number) => string;
      };
      FAQ: { // Add this
        CREATE: string;
        UPDATE: (id: number) => string;
        GET_BY_ID: (id: number) => string;
        GET_BY_COMPONENT_ID: (componentId: number) => string;
        DELETE: (id: number) => string;
        CLONE: string;
        CATEGORY: {
            CREATE: string;
            UPDATE: (id: number) => string;
            DELETE: (id: number) => string;
            GET_BY_COMPONENT_ID: (componentId: number) => string;
        };
        FAQ: {
            CREATE: string;
            UPDATE: (id: number) => string;
            DELETE: (id: number) => string;
            GET_BY_CATEGORY_ID: (categoryId: number) => string;
        };
    },
      VISIONARIES: {
        CREATE: string;
        UPDATE: (id: number) => string;
        GET_BY_ID: (id: number) => string;
        GET_BY_COMPONENT_ID: (componentId: number) => string;
        DELETE: (id: number) => string;
        CLONE: string;
        CATEGORY: {
          CREATE: string;
          UPDATE: (id: number) => string;
          DELETE: (id: number) => string;
          GET_BY_COMPONENT_ID: (componentId: number) => string;
        };
        PROFILE: {
          CREATE: string;
          UPDATE: (id: number) => string;
          DELETE: (id: number) => string;
          GET_BY_CATEGORY_ID: (categoryId: number) => string;
        };
      },
    PROGRAM_STRUCTURE: {
        CREATE: string;
        UPDATE: (id: number) => string;
        GET_BY_ID: (id: number) => string;
        GET_BY_COMPONENT_ID: (componentId: number) => string;
        DELETE: (id: number) => string;
        CLONE: string;
        SEMESTER: {
            CREATE: string;
            UPDATE: (id: number) => string;
            DELETE: (id: number) => string;
            GET_BY_COMPONENT_ID: (componentId: number) => string;
        };
        SUBJECT: {
            CREATE: string;
            UPDATE: (id: number) => string;
            DELETE: (id: number) => string;
            GET_BY_SEMESTER_ID: (semesterId: number) => string;
        };
    };
    ELECTIVE: {
        CREATE: string;
        UPDATE: (id: number) => string;
        GET_BY_ID: (id: number) => string;
        GET_BY_COMPONENT_ID: (componentId: number) => string;
        DELETE: (id: number) => string;
        CLONE: string;
        CATEGORY: {
            CREATE: string;
            UPDATE: (id: number) => string;
            DELETE: (id: number) => string;
            GET_BY_COMPONENT_ID: (componentId: number) => string;
        };
        SEMESTER: {
            CREATE: string;
            UPDATE: (id: number) => string;
            DELETE: (id: number) => string;
            GET_BY_COMPONENT_ID: (componentId: number) => string;
            GET_BY_CATEGORY_ID: (categoryId: number) => string;
        };
        SUBJECT: {
            CREATE: string;
            UPDATE: (id: number) => string;
            DELETE: (id: number) => string;
            GET_BY_SEMESTER_ID: (semesterId: number) => string;
        };
    };
    PROGRAM_FEE_V2: {
        CREATE: string;
        UPDATE: (id: number) => string;
        GET_BY_ID: (id: number) => string;
        GET_BY_COMPONENT_ID: (componentId: number) => string;
        GET_DATA_BY_COMPONENT_ID: (componentId: number) => string;
        DELETE: (id: number) => string;
    };
    PROGRAM_FEE: {
        CREATE: string;
        UPDATE: (id: number) => string;
        GET_BY_ID: (id: number) => string;
        GET_BY_COMPONENT_ID: (componentId: number) => string;
        GET_DATA_BY_COMPONENT_ID: (componentId: number) => string;
        DELETE: (id: number) => string;
        CLONE: string;
        TYPE: {
            CREATE: string;
            UPDATE: (id: number) => string;
            DELETE: (id: number) => string;
            GET_BY_ID: (id: number) => string;
            GET_BY_COMPONENT_ID: (componentId: number) => string;
        };
        CATEGORY: {
            CREATE: string;
            UPDATE: (id: number) => string;
            DELETE: (id: number) => string;
            GET_BY_ID: (id: number) => string;
            GET_BY_COMPONENT_ID: (componentId: number) => string;
        };
        SEMESTER: {
            CREATE: string;
            UPDATE: (id: number) => string;
            DELETE: (id: number) => string;
            GET_BY_ID: (id: number) => string;
            GET_BY_COMPONENT_ID: (componentId: number) => string;
        };
        VALUE: {
            CREATE: string;
            UPDATE: (id: number) => string;
            DELETE: (id: number) => string;
            GET_BY_ID: (id: number) => string;
            GET_BY_COMPONENT_ID: (componentId: number) => string;
        };
    };
    PROGRAM_STRUCTURE_V2: {
        CREATE: string;
        UPDATE: (id: number) => string;
        GET_BY_ID: (id: number) => string;
        GET_BY_COMPONENT_ID: (componentId: number) => string;
        GET_DATA_BY_COMPONENT_ID: (componentId: number) => string;
        DELETE: (id: number) => string;
        CLONE: string;
        SEMESTER: {
            CREATE: string;
            UPDATE: (id: number) => string;
            DELETE: (id: number) => string;
            GET_BY_ID: (id: number) => string;
            GET_BY_COMPONENT_ID: (componentId: number) => string;
        };
        CATEGORY: {
            CREATE: string;
            UPDATE: (id: number) => string;
            DELETE: (id: number) => string;
            GET_BY_ID: (id: number) => string;
            GET_BY_SEMESTER_ID: (semesterId: number) => string;
        };
        CATEGORY_ITEM: {
            CREATE: string;
            UPDATE: (id: number) => string;
            DELETE: (id: number) => string;
            GET_BY_ID: (id: number) => string;
            GET_BY_CATEGORY_ID: (categoryId: number) => string;
        };
        SUBJECT: {
            CREATE: string;
            UPDATE: (id: number) => string;
            DELETE: (id: number) => string;
            GET_BY_ID: (id: number) => string;
            GET_BY_SEMESTER_ID: (semesterId: number) => string;
        };
    };
    LIVE_LECTURE: {
      GET_EVENTS: string;
      GET_OPTIONS: string;
      GET_BY_ID: IdParam;
      CREATE: string;
      BULK_CREATE: string;
      UPDATE: IdParam;
      DELETE: IdParam;
    };
    LIVE_LECTURE_CONFIG: {
      CREATE: string;
      UPDATE: IdParam;
      DELETE: IdParam;
    };
      PROGRAM_BENEFITS: {
        CREATE: string;
        UPDATE: (id: number) => string;
      };
      CASE_STUDY: {
        CREATE: string;
        UPDATE: (id: number) => string;
      };
      BRAND: {
        CREATE: string;
        UPDATE: (id: number) => string;
      };
      INSTITUTES: {
        CREATE: string;
        UPDATE: (id: number) => string;
      };
      ICON_BUCKET: {
        GET_ALL: string;
        GET_BY_ID: IdParam;
        CREATE: string;
        UPDATE: IdParam;
        DELETE: IdParam;
        SEARCH: string;
      };

      USER: {
        GET_ALL: string;
        GET_BY_ID: IdParam;
        CREATE: string;
        UPDATE: IdParam;
        DELETE: IdParam;
      };

      ROLE: {
        GET_ALL: string;
        GET_BY_ID: IdParam;
      };
    };

export const ADMIN_API_ENDPOINTS: AdminApiEndpoints = {
      UPLOAD_FILE: "/upload",

      COURSE: {
        CREATE: "/course",
        GET_BY_UNIVERSITY_AND_VARIANT: (universityId: number, variant: string) => `/course/university/${universityId}/variant/${variant}`,
        GET_BY_UNIVERSITY_SETTINGS_ID: (universitySettingsId: number) => `/course/university-settings/${universitySettingsId}`,
        GET_BY_UNIVERSITY_ID: (universityId: number) => `/course/university/${universityId}`,
        GET_ACTIVE_BY_UNIVERSITY_ID: (universityId: number) => `/course/university/${universityId}/active`,
        UPDATE: (id: number) => `/course/${id}`,
        DELETE: (id: number) => `/course/${id}`,
      },

      UNIVERSITY_SETTINGS: {
        GET_BY_UNIVERSITY_ID: (universityId: number) => `/university-settings/university/${universityId}`,
        GET_BY_UNIVERSITY_AND_SECTION: (universityId: number, section: string) => `/university-settings/university/${universityId}/section/${section}`,
        UPDATE_BY_UNIVERSITY_ID: (universityId: number) => `/university-settings/university/${universityId}`,
        CREATE_BY_UNIVERSITY_ID: (universityId: number) => `/university-settings/university/${universityId}`,
      },

      UNIVERSITY: {
        GET_CONTENT: (university_id) => `/university/${university_id}`,
        UPDATE_INFO: (id) => `/university/${id}`,
    
        ABOUT: {
          GET_DETAILS_BY_ID: (id) => `/admin/universityInfo/${id}`,
          UPDATE: (id) => `/university/${id}`,
        },
      },
      BANNER: {
        CREATE: "/banner",
        UPDATE: (id: number) => `/banner/${id}`,
        DELETE: (id: number) => `/banner/${id}`,
        GET_ALL: (pageTypeId: number) => `/banner/${pageTypeId}`,
      },

      HEADER: {
        CREATE: "/header",
        UPDATE: (id: number) => `/header/${id}`,
        DELETE: (id: number) => `/header/${id}`,
        GET_ALL: (pageTypeId: number) => `/header/${pageTypeId}`,
      },

      LEARNERS: {
        CREATE: '/learners',
        UPDATE: (id: number) => `/learners/${id}`,
      },

      SCHOLAR: {
        CREATE: '/scholar',
        UPDATE: (id: number) => `/scholar/${id}`,
      },

      ABOUT: {
        CREATE: '/about',
        UPDATE: (id: number) => `/about/${id}`,
      },
      ACCORDION: {
        CREATE: '/accordion',
        UPDATE: (id: number) => `/accordion/${id}`,
        GET_BY_PAGE_ID: (pageId: number) => `/accordion/${pageId}`,
        DELETE: (id: number) => `/accordion/${id}`,
      },
      ACCREDITATION: {
        CREATE: '/accreditations',
        UPDATE: (id: number) => `/accreditations/${id}`,
      },

      KEY_NUMBERS: {
        CREATE: '/key-numbers',
        UPDATE: (id: number) => `/key-numbers/${id}`,
      },

      DIGITAL_LEARNING: {
        CREATE: '/digital-learning',
        UPDATE: (id: number) => `/digital-learning/${id}`,
      },

      ACADEMIC_DELIVERABLES: {
        CREATE: '/deliverable',
        UPDATE: (id: number) => `/deliverable/${id}`,
      },

      MESSAGE: {
        CREATE: '/message',
        UPDATE: (id: number) => `/message/${id}`,
      },

      MOBILE_APP: {
        CREATE: '/mobile-app',
        UPDATE: (id: number) => `/mobile-app/${id}`,
      },

      PLACEMENTS: {
        CREATE: '/placements',
        UPDATE: (id: number) => `/placements/${id}`,
      },
      
      TESTIMONIALS: {
        CREATE: '/testimonials',
        UPDATE: (id: number) => `/testimonials/${id}`,
      },

      RECRUITERS: {
        CREATE: '/recruiters',
        UPDATE: (id: number) => `/recruiters/${id}`,
      },

      ELIGIBILITY: {
        CREATE: '/eligibility',
        UPDATE: (id: number) => `/eligibility/${id}`,
        CLONE: '/eligibility/clone',
        GET_BY_COMPONENT_ID: (componentId: number) =>
          `/eligibility/component/${componentId}`,
        CATEGORY: {
          CREATE: '/eligibility/category',
          UPDATE: (id: number) => `/eligibility/category/${id}`,
          DELETE: (id: number) => `/eligibility/category/${id}`,
          GET_BY_COMPONENT_ID: (componentId: number) =>
            `/eligibility/category/component/${componentId}`,
          GET_BY_ID: (id: number) => `/eligibility/category/${id}`,
        },
      },

      COUNSELING: {
        CREATE: '/counseling',
        UPDATE: (id: number) => `/counseling/${id}`,
        GET_BY_PAGE_ID: (pageId: number) => `/counseling/${pageId}`,
        DELETE: (id: number) => `/counseling/${id}`,
      },

      COURSE_SPECIALISATION: {
        CREATE: '/course-specialisations',
        UPDATE: (id: number) => `/course-specialisations/${id}`,
        GET_BY_ID: (id: number) => `/course-specialisations/${id}`,
        GET_BY_PAGE_ID: (pageId: number) => `/course-specialisations/page/${pageId}`,
        DELETE: (id: number) => `/course-specialisations/${id}`,
      },

      HIGHER_QUALIFICATION: {
        CREATE: '/higher-qualification',
        UPDATE: (id: number) => `/higher-qualification/${id}`,
        GET_BY_UNIVERSITY_SETTINGS_ID: (universitySettingsId: number) => `/higher-qualification/university-settings/${universitySettingsId}`,
        DELETE: (id: number) => `/higher-qualification/${id}`,
      },

      LEAD_DROP_FORM: {
        CREATE: '/lead-drop-form',
        UPDATE: (id: number) => `/lead-drop-form/${id}`,
        GET_BY_UNIVERSITY_ID: (universityId: number) => `/lead-drop-form/university/${universityId}`,
        GET_BY_UNIVERSITY_AND_VARIANT: (universityId: number, variant: string) => `/lead-drop-form/university/${universityId}/variant/${variant}`,
        DELETE: (id: number) => `/lead-drop-form/${id}`,
      },

      LEAD_DROP_POPUP: {
        CREATE: '/lead-drop-popup',
        UPDATE: (id: number) => `/lead-drop-popup/${id}`,
        GET_BY_UNIVERSITY_ID: (universityId: number) => `/lead-drop-popup/university/${universityId}`,
        GET_BY_UNIVERSITY_AND_VARIANT: (universityId: number, variant: string) => `/lead-drop-popup/university/${universityId}/variant/${variant}`,
        DELETE: (id: number) => `/lead-drop-popup/${id}`,
      },

      LEAD_FORM_OPTIONS: {
        GROUPS: (kind: string, universityId: number) =>
          `/lead-form-options/groups/${kind}?university_id=${universityId}`,
        CREATE_GROUP: (kind: string) => `/lead-form-options/groups/${kind}`,
        UPDATE_GROUP: (kind: string, id: number) => `/lead-form-options/groups/${kind}/${id}`,
        DELETE_GROUP: (kind: string, id: number) => `/lead-form-options/groups/${kind}/${id}`,
        ASSIGN_ITEMS: (kind: string, id: number) => `/lead-form-options/groups/${kind}/${id}/items`,
        ITEMS: (kind: string, universityId: number) =>
          `/lead-form-options/items/${kind}?university_id=${universityId}`,
        CREATE_ITEM: (kind: string) => `/lead-form-options/items/${kind}`,
        UPDATE_ITEM: (kind: string, id: number) => `/lead-form-options/items/${kind}/${id}`,
        DELETE_ITEM: (kind: string, id: number, universityId: number) =>
          `/lead-form-options/items/${kind}/${id}?university_id=${universityId}`,
        SET_ITEMS_GROUP: (kind: string) => `/lead-form-options/items/${kind}/assign`,
        RESOLVE: (source: string, universityId: number, group?: string) =>
          `/lead-form-options/resolve?source=${source}&university_id=${universityId}${group ? `&group=${encodeURIComponent(group)}` : ''}`,
      },

      CUSTOM_LEAD_FORM: {
        DESTINATIONS: '/custom-lead-form/destinations',
        USAGE: (id: number, universityId: number) =>
          `/custom-lead-form/${id}/usage?university_id=${universityId}`,
        BULK_LINK: (id: number) => `/custom-lead-form/${id}/bulk-link`,
        BULK_UNLINK: (id: number) => `/custom-lead-form/${id}/bulk-unlink`,
        LIST: (universityId: number, formType?: string) =>
          `/custom-lead-form?university_id=${universityId}${formType ? `&form_type=${formType}` : ''}`,
        CREATE: '/custom-lead-form',
        GET_BY_ID: (id: number) => `/custom-lead-form/${id}`,
        UPDATE: (id: number) => `/custom-lead-form/${id}`,
        DELETE: (id: number) => `/custom-lead-form/${id}`,
      },

      LEAD_FORM_CONFIG: {
        CATALOG: '/lead-form-config/catalog',
        VALIDATE: '/lead-form-config/validate',
        LIST: (universityId: number) => `/lead-form-config?university_id=${universityId}`,
        CREATE: '/lead-form-config',
        GET_BY_ID: (id: number) => `/lead-form-config/${id}`,
        UPDATE: (id: number) => `/lead-form-config/${id}`,
        DELETE: (id: number) => `/lead-form-config/${id}`,
      },

      MOBILE_LEAD_FORM: {
        CREATE: '/mobile-lead-form',
        UPDATE: (id: number) => `/mobile-lead-form/${id}`,
        GET_BY_COMPONENT_ID: (componentId: number) => `/mobile-lead-form/component/${componentId}`,
        DELETE: (id: number) => `/mobile-lead-form/${id}`,
      },

      PROGRAM_PROSPECTS: {
        CREATE: '/program-prospects',
        UPDATE: (id: number) => `/program-prospects/${id}`,
        GET_BY_PAGE_ID: (pageId: number) => `/program-prospects/${pageId}`,
        DELETE: (id: number) => `/program-prospects/${id}`,
      },

      SPECIALISATION: {
        CREATE: '/specialisation',
        UPDATE: (id: number) => `/specialisation/${id}`,
      },

      CAREER_PROSPECTS: {
        CREATE: '/career-prospects',
        UPDATE: (id: number) => `/career-prospects/${id}`,
      },

      CERTIFICATION: {
        CREATE: '/certification',
        UPDATE: (id: number) => `/certification/${id}`,
      },

      APPLICATION_PROCESS: {
        CREATE: '/application-process',
        UPDATE: (id: number) => `/application-process/${id}`,
      },

      SKILLS: {
        CREATE: '/skills',
        UPDATE: (id: number) => `/skills/${id}`,
      },

      COMPARISON: {
        CREATE: '/comparison',
        UPDATE: (id: number) => `/comparison/${id}`,
      },

      LEADERS: {
        CREATE: '/leaders',
        UPDATE: (id: number) => `/leaders/${id}`,
      },

      WHO_IS_THIS_PROGRAM_FOR: {
        CREATE: '/who-is-this-program-for',
        UPDATE: (id: number) => `/who-is-this-program-for/${id}`,
      },

      BANNER_VIDEO: {
        CREATE: '/banner-video',
        UPDATE: (id: number) => `/banner-video/${id}`,
      },

      WALK_THROUGH: {
        CREATE: '/walk-through',
        UPDATE: (id: number) => `/walk-through/${id}`,
      },

      LIFE_MILESTONE: {
        CREATE: '/life-milestone',
        UPDATE: (id: number) => `/life-milestone/${id}`,
      },

      SPECIALISATION_CAROUSEL: {
        CREATE: '/specialisation-carousel',
        UPDATE: (id: number) => `/specialisation-carousel/${id}`,
      },

      ENROLLMENTS: {
        CREATE: '/enrollments',
        UPDATE: (id: number) => `/enrollments/${id}`,
      },

      SUCCESS_STORIES: {
        CREATE: '/success-stories',
        UPDATE: (id: number) => `/success-stories/${id}`,
      },

      WHAT_MAKES_COURSE_DIFFERENT: {
        CREATE: '/what-makes-course-different',
        UPDATE: (id: number) => `/what-makes-course-different/${id}`,
      },

      VICE_CHANCELLOR: {
        CREATE: '/vice-chancellor',
        UPDATE: (id: number) => `/vice-chancellor/${id}`,
      },

      FACULTY: {
        CREATE: '/faculty',
        UPDATE: (id: number) => `/faculty/${id}`,
      },

      MASTERCLASS: {
        CREATE: '/masterclass',
        UPDATE: (id: number) => `/masterclass/${id}`,
      },

      FOOTER: {
        CREATE: '/footer',
        UPDATE: (id: number) => `/footer/${id}`,
        GET_BY_ID: (id: number) => `/footer/${id}`,
        GET_BY_COMPONENT_ID: (componentId: number) => `/footer/component/${componentId}`,
        DELETE: (id: number) => `/footer/${id}`,
        CLONE: "/footer/clone",
        CATEGORY: {
            CREATE: "/footer/category",
            UPDATE: (id: number) => `/footer/category/${id}`,
            DELETE: (id: number) => `/footer/category/${id}`,
            GET_BY_COMPONENT_ID: (componentId: number) => `/footer/category/component/${componentId}`,
        },
        ITEM: {
            CREATE: "/footer/item",
            UPDATE: (id: number) => `/footer/item/${id}`,
            DELETE: (id: number) => `/footer/item/${id}`,
            GET_BY_CATEGORY_ID: (categoryId: number) => `/footer/item/category/${categoryId}`,
        },
      },

      SUBSCRIBE: {
        CREATE: '/subscribe',
        UPDATE: (id: number) => `/subscribe/${id}`,
      },

      PROGRAM_CARDS: {
        CREATE: '/program-cards',
        UPDATE: (id: number) => `/program-cards/${id}`,
        GET_BY_COMPONENT_ID: (componentId: number) => `/program-cards/component/${componentId}`,
        CLONE: '/program-cards/clone',
        CATEGORY: {
          CREATE: '/program-cards/category',
          UPDATE: (id: number) => `/program-cards/category/${id}`,
          DELETE: (id: number) => `/program-cards/category/${id}`,
          GET_BY_COMPONENT_ID: (componentId: number) => `/program-cards/category/component/${componentId}`,
        },
        CARD: {
          CREATE: '/program-cards/card',
          UPDATE: (id: number) => `/program-cards/card/${id}`,
          DELETE: (id: number) => `/program-cards/card/${id}`,
          GET_BY_CATEGORY_ID: (categoryId: number) => `/program-cards/card/category/${categoryId}`,
        },
      },

      COURSE_OUTCOME: {
        CREATE: '/course-outcome',
        UPDATE: (id: number) => `/course-outcome/${id}`,
      },

      THANK_YOU: {
        CREATE: '/thank-you',
        UPDATE: (id: number) => `/thank-you/${id}`,
      },
      RICH_TEXT_EDITOR: {
        CREATE: '/rich-text-editor',
        UPDATE: (id: number) => `/rich-text-editor/${id}`,
      },
      BLOG_WITH_LEAD: {
        CREATE: '/blog-with-lead',
        UPDATE: (id: number) => `/blog-with-lead/${id}`,
      },
      LATEST_BLOG: {
        CREATE: '/latest-blog',
        UPDATE: (id: number) => `/latest-blog/${id}`,
        SOURCES: (pageId: number) => `/latest-blog/sources?page_id=${pageId}`,
      },
      POPULAR_BLOG: {
        CREATE: '/popular-blog',
        UPDATE: (id: number) => `/popular-blog/${id}`,
        SOURCES: (pageId: number) => `/popular-blog/sources?page_id=${pageId}`,
      },
      BLOG_LIST: {
        CREATE: '/blog-list',
        UPDATE: (id: number) => `/blog-list/${id}`,
      },
      BLOG_CATEGORY: {
        LIST: '/blog-category',
        GET_BY_ID: (id: number) => `/blog-category/${id}`,
        CREATE: '/blog-category',
        UPDATE: (id: number) => `/blog-category/${id}`,
        DELETE: (id: number) => `/blog-category/${id}`,
      },
      AUTHOR: {
        LIST: '/author',
        GET_BY_ID: (id: number) => `/author/${id}`,
        LINKED_PAGES: (id: number) => `/author/${id}/linked-pages`,
        CREATE: '/author',
        UPDATE: (id: number) => `/author/${id}`,
        DELETE: (id: number) => `/author/${id}`,
      },
      AUTHOR_PROFILE: {
        CREATE: '/author-profile',
        UPDATE: (id: number) => `/author-profile/${id}`,
      },
      AUTHOR_CARD: {
        CREATE: '/author-card',
        UPDATE: (id: number) => `/author-card/${id}`,
      },
      AUTHOR_BYLINE: {
        CREATE: '/author-byline',
        UPDATE: (id: number) => `/author-byline/${id}`,
      },
      COUNSELOR_CALL_CTA: {
        CREATE: '/counselor-call-cta',
        UPDATE: (id: number) => `/counselor-call-cta/${id}`,
      },
      BREADCRUMB_BANNER: {
        CREATE: '/breadcrumb-banner',
        UPDATE: (id: number) => `/breadcrumb-banner/${id}`,
      },
      BLOG_INLINE_IMAGE: {
        CREATE: '/blog-inline-image',
        UPDATE: (id: number) => `/blog-inline-image/${id}`,
      },
      PARA_TEXT: {
        CREATE: '/para-text',
        UPDATE: (id: number) => `/para-text/${id}`,
      },
      HEADING: {
        CREATE: '/heading',
        UPDATE: (id: number) => `/heading/${id}`,
      },
      SKILL_CARDS: {
        CREATE: '/skill-cards',
        UPDATE: (id: number) => `/skill-cards/${id}`,
      },
      LEARN_FROM_LEADERS: {
        CREATE: '/learn-from-leaders',
        UPDATE: (id: number) => `/learn-from-leaders/${id}`,
        GET_BY_COMPONENT_ID: (componentId: number) =>
          `/learn-from-leaders/component/${componentId}`,
      },
      REFERRAL_FORM: {
        CREATE: '/referral-form',
        UPDATE: (id: number) => `/referral-form/${id}`,
      },
      INFLUENCER_FORM: {
        CREATE: '/influencer-form',
        UPDATE: (id: number) => `/influencer-form/${id}`,
      },
      GRIEVANCE_FORM: {
        CREATE: '/grievance-form',
        UPDATE: (id: number) => `/grievance-form/${id}`,
      },

      PAGE: {
        GET_ALL: '/page/all',
        GET_BY_ID: (id: string | number) => `/admin/${id}`,
        CREATE: '/page',
        UPDATE: (id: string | number) => `/page/${id}`,
        DELETE: (id: string | number) => `/page/${id}`,
        CLONE: (id: string | number) => `/page/clone/${id}`,
      },

      PAGE_COMPONENT: {
        CREATE: '/page-component',
        GET_BY_PAGE_ID: (page_id: number) => `/page-component/page/${page_id}`,
        GET_BY_ID: (id: number) => `/page-component/${id}`,
        UPDATE: (id: number) => `/page-component/${id}`,
        DELETE: (id: number) => `/page-component/${id}`,
        REORDER: (page_id: number) => `/page-component/reorder/${page_id}`,
      },

      WIDGET_BLOCK: {
        LIST: '/widget-block',
        GET_BY_ID: (id: string | number) => `/widget-block/${id}`,
        CREATE: '/widget-block',
        UPDATE: (id: string | number) => `/widget-block/${id}`,
        DELETE: (id: string | number) => `/widget-block/${id}`,
        USAGE: (id: string | number) => `/widget-block/${id}/usage`,
        BULK_PLACE: (id: string | number) => `/widget-block/${id}/bulk-place`,
        BULK_REMOVE: (id: string | number) => `/widget-block/${id}/bulk-remove`,
      },

      WIDGET_MANAGEMENT: {
        INVENTORY: '/widget-management/inventory',
        USAGE: '/widget-management/usage',
        BULK_DELETE: '/widget-management/bulk-delete',
        BULK_CLONE: '/widget-management/bulk-clone',
      },

      NAVBAR: {
        CREATE: "/nav-bar",
        UPDATE: (id: number) => `/nav-bar/${id}`,
        GET_BY_ID: (id: number) => `/nav-bar/${id}`,
        CLONE: "/nav-bar/clone",
      },
      MENU_ITEM: {
        CREATE: "/menu-item",
        UPDATE: (id: number) => `/menu-item/${id}`,
        DELETE: (id: number) => `/menu-item/${id}`,
        GET_ALL: "/menu-item",
        GET_BY_NAVBAR_ID: (navbarId: number) => `/menu-item/navbar/${navbarId}`,
      },
      FAQ: { // Add this
        CREATE: "/faq",
        UPDATE: (id: number) => `/faq/${id}`,
        GET_BY_ID: (id: number) => `/faq/${id}`,
        GET_BY_COMPONENT_ID: (componentId: number) => `/faq/component/${componentId}`,
        DELETE: (id: number) => `/faq/${id}`,
        CLONE: "/faq/clone",
        CATEGORY: {
            CREATE: "/faq/category", // Changed from "/faq-category"
            UPDATE: (id: number) => `/faq/category/${id}`, // Changed from `/faq-category/${id}`
            DELETE: (id: number) => `/faq/category/${id}`, // Changed from `/faq-category/${id}`
            GET_BY_COMPONENT_ID: (componentId: number) => `/faq/category/component/${componentId}`, // Changed from `/faq-category/component/${componentId}`
        },
        FAQ: {
            CREATE: "/faq/item", // Changed from "/faq-item"
            UPDATE: (id: number) => `/faq/item/${id}`, // Changed from `/faq-item/${id}`
            DELETE: (id: number) => `/faq/item/${id}`, // Changed from `/faq-item/${id}`
            GET_BY_CATEGORY_ID: (categoryId: number) => `/faq/item/category/${categoryId}`, // Changed from `/faq-item/category/${categoryId}`
        },
    },
      VISIONARIES: {
        CREATE: "/visionaries",
        UPDATE: (id: number) => `/visionaries/${id}`,
        GET_BY_ID: (id: number) => `/visionaries/${id}`,
        GET_BY_COMPONENT_ID: (componentId: number) => `/visionaries/component/${componentId}`,
        DELETE: (id: number) => `/visionaries/${id}`,
        CLONE: "/visionaries/clone",
        CATEGORY: {
          CREATE: "/visionaries/category",
          UPDATE: (id: number) => `/visionaries/category/${id}`,
          DELETE: (id: number) => `/visionaries/category/${id}`,
          GET_BY_COMPONENT_ID: (componentId: number) =>
            `/visionaries/category/component/${componentId}`,
        },
        PROFILE: {
          CREATE: "/visionaries/profile",
          UPDATE: (id: number) => `/visionaries/profile/${id}`,
          DELETE: (id: number) => `/visionaries/profile/${id}`,
          GET_BY_CATEGORY_ID: (categoryId: number) =>
            `/visionaries/profile/category/${categoryId}`,
        },
      },
    PROGRAM_STRUCTURE: {
        CREATE: "/program-structure",
        UPDATE: (id: number) => `/program-structure/${id}`,
        GET_BY_ID: (id: number) => `/program-structure/${id}`,
        GET_BY_COMPONENT_ID: (componentId: number) => `/program-structure/component/${componentId}`,
        DELETE: (id: number) => `/program-structure/${id}`,
        CLONE: "/program-structure/clone",
        SEMESTER: {
            CREATE: "/program-structure/semester",
            UPDATE: (id: number) => `/program-structure/semester/${id}`,
            DELETE: (id: number) => `/program-structure/semester/${id}`,
            GET_BY_COMPONENT_ID: (componentId: number) => `/program-structure/semester/component/${componentId}`,
        },
        SUBJECT: {
            CREATE: "/program-structure/subject",
            UPDATE: (id: number) => `/program-structure/subject/${id}`,
            DELETE: (id: number) => `/program-structure/subject/${id}`,
            GET_BY_SEMESTER_ID: (semesterId: number) => `/program-structure/subject/semester/${semesterId}`,
        },
    },
    ELECTIVE: {
        CREATE: "/elective",
        UPDATE: (id: number) => `/elective/${id}`,
        GET_BY_ID: (id: number) => `/elective/${id}`,
        GET_BY_COMPONENT_ID: (componentId: number) => `/elective/component/${componentId}`,
        DELETE: (id: number) => `/elective/${id}`,
        CLONE: "/elective/clone",
        CATEGORY: {
            CREATE: "/elective/category",
            UPDATE: (id: number) => `/elective/category/${id}`,
            DELETE: (id: number) => `/elective/category/${id}`,
            GET_BY_COMPONENT_ID: (componentId: number) => `/elective/category/component/${componentId}`,
        },
        SEMESTER: {
            CREATE: "/elective/semester",
            UPDATE: (id: number) => `/elective/semester/${id}`,
            DELETE: (id: number) => `/elective/semester/${id}`,
            GET_BY_COMPONENT_ID: (componentId: number) => `/elective/semester/component/${componentId}`,
            GET_BY_CATEGORY_ID: (categoryId: number) => `/elective/semester/category/${categoryId}`,
        },
        SUBJECT: {
            CREATE: "/elective/subject",
            UPDATE: (id: number) => `/elective/subject/${id}`,
            DELETE: (id: number) => `/elective/subject/${id}`,
            GET_BY_SEMESTER_ID: (semesterId: number) => `/elective/item/semester/${semesterId}`,
        },
    },
    PROGRAM_FEE_V2: {
        CREATE: "/program-fee-v2",
        UPDATE: (id: number) => `/program-fee-v2/${id}`,
        GET_BY_ID: (id: number) => `/program-fee-v2/${id}`,
        GET_BY_COMPONENT_ID: (componentId: number) => `/program-fee-v2/component/${componentId}`,
        GET_DATA_BY_COMPONENT_ID: (componentId: number) => `/program-fee-v2/component/${componentId}/data`,
        DELETE: (id: number) => `/program-fee-v2/${id}`,
    },
    PROGRAM_FEE: {
        CREATE: "/program-fee",
        UPDATE: (id: number) => `/program-fee/${id}`,
        GET_BY_ID: (id: number) => `/program-fee/${id}`,
        GET_BY_COMPONENT_ID: (componentId: number) => `/program-fee/component/${componentId}`,
        GET_DATA_BY_COMPONENT_ID: (componentId: number) => `/program-fee/component/${componentId}/data`,
        DELETE: (id: number) => `/program-fee/${id}`,
        CLONE: "/program-fee/clone",
        TYPE: {
            CREATE: "/program-fee/type",
            UPDATE: (id: number) => `/program-fee/type/${id}`,
            DELETE: (id: number) => `/program-fee/type/${id}`,
            GET_BY_ID: (id: number) => `/program-fee/type/${id}`,
            GET_BY_COMPONENT_ID: (componentId: number) => `/program-fee/type/component/${componentId}`,
        },
        CATEGORY: {
            CREATE: "/program-fee/category",
            UPDATE: (id: number) => `/program-fee/category/${id}`,
            DELETE: (id: number) => `/program-fee/category/${id}`,
            GET_BY_ID: (id: number) => `/program-fee/category/${id}`,
            GET_BY_COMPONENT_ID: (componentId: number) => `/program-fee/category/component/${componentId}`,
        },
        SEMESTER: {
            CREATE: "/program-fee/semester",
            UPDATE: (id: number) => `/program-fee/semester/${id}`,
            DELETE: (id: number) => `/program-fee/semester/${id}`,
            GET_BY_ID: (id: number) => `/program-fee/semester/${id}`,
            GET_BY_COMPONENT_ID: (componentId: number) => `/program-fee/semester/component/${componentId}`,
        },
        VALUE: {
            CREATE: "/program-fee/value",
            UPDATE: (id: number) => `/program-fee/value/${id}`,
            DELETE: (id: number) => `/program-fee/value/${id}`,
            GET_BY_ID: (id: number) => `/program-fee/value/${id}`,
            GET_BY_COMPONENT_ID: (componentId: number) => `/program-fee/value/component/${componentId}`,
        },
    },
    PROGRAM_STRUCTURE_V2: {
        CREATE: "/program-structure-v2",
        UPDATE: (id: number) => `/program-structure-v2/${id}`,
        GET_BY_ID: (id: number) => `/program-structure-v2/${id}`,
        GET_BY_COMPONENT_ID: (componentId: number) => `/program-structure-v2/component/${componentId}`,
        GET_DATA_BY_COMPONENT_ID: (componentId: number) => `/program-structure-v2/component/${componentId}/data`,
        DELETE: (id: number) => `/program-structure-v2/${id}`,
        CLONE: "/program-structure-v2/clone",
        SEMESTER: {
            CREATE: "/program-structure-v2/semester",
            UPDATE: (id: number) => `/program-structure-v2/semester/${id}`,
            DELETE: (id: number) => `/program-structure-v2/semester/${id}`,
            GET_BY_ID: (id: number) => `/program-structure-v2/semester/${id}`,
            GET_BY_COMPONENT_ID: (componentId: number) => `/program-structure-v2/semester/component/${componentId}`,
        },
        CATEGORY: {
            CREATE: "/program-structure-v2/category",
            UPDATE: (id: number) => `/program-structure-v2/category/${id}`,
            DELETE: (id: number) => `/program-structure-v2/category/${id}`,
            GET_BY_ID: (id: number) => `/program-structure-v2/category/${id}`,
            GET_BY_SEMESTER_ID: (semesterId: number) => `/program-structure-v2/category/semester/${semesterId}`,
        },
        CATEGORY_ITEM: {
            CREATE: "/program-structure-v2/category-item",
            UPDATE: (id: number) => `/program-structure-v2/category-item/${id}`,
            DELETE: (id: number) => `/program-structure-v2/category-item/${id}`,
            GET_BY_ID: (id: number) => `/program-structure-v2/category-item/${id}`,
            GET_BY_CATEGORY_ID: (categoryId: number) => `/program-structure-v2/category-item/category/${categoryId}`,
        },
        SUBJECT: {
            CREATE: "/program-structure-v2/subject",
            UPDATE: (id: number) => `/program-structure-v2/subject/${id}`,
            DELETE: (id: number) => `/program-structure-v2/subject/${id}`,
            GET_BY_ID: (id: number) => `/program-structure-v2/subject/${id}`,
            GET_BY_SEMESTER_ID: (semesterId: number) => `/program-structure-v2/subject/semester/${semesterId}`,
        },
    },
    LIVE_LECTURE: {
      GET_EVENTS: "/liveLecture",
      GET_OPTIONS: "/liveLecture/options",
      GET_BY_ID: (id: string | number) => `/liveLecture/${id}`,
      CREATE: "/liveLecture",
      BULK_CREATE: "/liveLecture/bulk",
      UPDATE: (id: string | number) => `/liveLecture/${id}`,
      DELETE: (id: string | number) => `/liveLecture/${id}`,
    },
    LIVE_LECTURE_CONFIG: {
      CREATE: "/liveLectureConfig",
      UPDATE: (id: string | number) => `/liveLectureConfig/${id}`,
      DELETE: (id: string | number) => `/liveLectureConfig/${id}`,
    },
      PROGRAM_BENEFITS: {
        CREATE: '/program-benefits',
        UPDATE: (id: number) => `/program-benefits/${id}`,
      },
      CASE_STUDY: {
        CREATE: '/case-study',
        UPDATE: (id: number) => `/case-study/${id}`,
      },
      BRAND: {
        CREATE: '/brand',
        UPDATE: (id: number) => `/brand/${id}`,
      },
      INSTITUTES: {
        CREATE: '/institutes',
        UPDATE: (id: number) => `/institutes/${id}`,
      },
      ICON_BUCKET: {
        GET_ALL: "/icon-bucket",
        GET_BY_ID: (id) => `/icon-bucket/${id}`,
        CREATE: "/icon-bucket",
        UPDATE: (id) => `/icon-bucket/${id}`,
        DELETE: (id) => `/icon-bucket/${id}`,
        SEARCH: "/icon-bucket/search",
      },

      USER: {
        GET_ALL: "/user/all",
        GET_BY_ID: (id) => `/user/${id}`,
        CREATE: "/user/register",
        UPDATE: (id) => `/user/${id}`,
        DELETE: (id) => `/user/${id}`,
      },

      ROLE: {
        GET_ALL: "/role/all",
        GET_BY_ID: (id) => `/role/${id}`,
      },
    };

